module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "nav-desktop"
  }, [_c('div', {
    staticClass: "nav-desktop__container"
  }, [_c('div', {
    staticClass: "nav-desktop__logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "summers_logo"
    }
  })], 1)], 1), _c('div', {
    staticClass: "nav-desktop__navbar"
  }, [_vm._l((_vm.links), function(nav, i) {
    return (nav.navigation) ? _c('span', {
      key: i,
      staticClass: "nav-desktop__link"
    }, [_c('router-link', {
      attrs: {
        "to": nav.path
      }
    }, [_vm._v(_vm._s(nav.linkName))])], 1) : _vm._e()
  }), _c('span', {
    staticClass: "manual_nav"
  }, [_c('span', {
    staticClass: "nav-desktop__link",
    on: {
      "click": _vm.scrollHomeConsulttt
    }
  }, [_vm._v("Invisalign      ")]), _c('span', {
    staticClass: "nav-desktop__link",
    on: {
      "click": _vm.scrollHomeConsult
    }
  }, [_vm._v("3D Imaging")]), _c('span', {
    staticClass: "nav-desktop__link",
    on: {
      "click": _vm.scrollHomeConsultt
    }
  }, [_vm._v("Digital Impressions        ")])]), _c('div', {
    staticClass: "nav-desktop__button-group"
  }, [_c('div', {
    staticClass: "nav-desktop__phone"
  }, [_c('Icon', {
    attrs: {
      "name": "phone"
    }
  }), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.information.phone)
    }
  })], 1), _c('div', {
    on: {
      "click": _vm.toForm
    }
  }, [_c('router-link', {
    staticClass: "nav-desktop__button",
    attrs: {
      "to": "/get-started"
    }
  }, [_vm._v("         Request Appointment")])], 1)])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08cba188","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/navigation/nav-desktop/nav-desktop.pug
// module id = 534
// module chunks = 1